/**
 * @ngdoc filters
 * @memberof mercury.filters
 * @name percent
 */
angular.module('mercury.filters.percent', [])
.filter('percent', ["$filter", function($filter) {
  return function(input, precision) {
    if (input === null || input === undefined) {
      return '-';
    }

    if (precision == null) {
      precision = 2;
    }
    return $filter('number')(input, precision) + '%';
  };
}]);
